import type { ReactNode } from "react";
import type { Category } from "@/types";

interface CategoryHeroProps {
  category: Category;
  children: ReactNode;
}

export default function CategoryHero({ category, children }: CategoryHeroProps) {
  const overlay = category.heroOverlay;
  const dark = `rgba(43, 33, 28, ${overlay})`;

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={category.heroDesktop}
          alt={`Categoria ${category.name} — calçados e acessórios Auréa`}
          title={`${category.name} — Auréa calçados femininos e acessórios`}
          className="hidden h-full w-full object-cover md:block"
          style={{ objectPosition: category.heroFocalDesktop }}
        />
        <img
          src={category.heroMobile}
          alt={`Categoria ${category.name} — calçados e acessórios Auréa`}
          title={`${category.name} — Auréa calçados femininos e acessórios`}
          className="block h-full w-full object-cover md:hidden"
          style={{ objectPosition: category.heroFocalMobile }}
        />
        <div className="absolute inset-0" style={{ backgroundColor: dark }} />
        <div className="absolute inset-0 hidden bg-gradient-to-r from-foreground-950/70 via-foreground-950/15 to-transparent md:block" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent md:hidden" />
      </div>
      <div className="relative z-10 flex min-h-[420px] w-full flex-col justify-end px-4 pb-10 pt-16 md:min-h-[520px] md:justify-center md:px-8 md:pb-16 md:pt-20">
        <div className="mx-auto w-full max-w-7xl">{children}</div>
      </div>
    </section>
  );
}